import React, { Component } from 'react';
import { Row, Col, Button, ListGroupItem, Container } from 'reactstrap';
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import Slider from "react-slick";
import c from '../../constants/Colors';
import Pagination from '../reusable/Pagination';
import product from '../../assets/img/product.png';
import repuestos from '../../assets/img/repuestos.png';
import { ListarSistemaRepuestos } from '../../store/sagas/pedidoApi';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { data } from '../../constants/Constants';
import { AuthContext } from "../../store/provider/AuthProvider";
import ModalAddCart from "../reusable/modals/AddCart";
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import ModalImageZoom2 from '../reusable/modals/ImageZoom2';
import CardPrecios from '../reusable/CardPrecios';
import Spinner from "../reusable/Loader";

const CardRepuestos = ({ data, event, eventFavorito, eventCounter, pantalla, auth, isMobile, zoom }) => {

  let card;
  console.log('isMobile', isMobile)
  if (isMobile) {
    card = (
      <div className="card_product_horizontal">
        <div className="cphLeftImage">
          <div style={{ cursor: 'pointer' }} onClick={() => zoom(data.fotos)}>
            <img src={data.pathImage} />
          </div>
        </div>
        <div className="cphTextCenter">
          <h6 className="paragraph-2 bold mb-1 azul">{data.maktx}</h6>
          <span className="paragraph-3 mb-3" style={{ color: c.grisMedio }}>SKU: {data.codmaterial}</span>
          <CardPrecios data={data.precios} escalas={data.escalas} cantidad={data.cantidad} className="cardPrice" />
          {/* <span className="paragraph-3 previousPrice" style={{color: c.grisMedio}}>{data.precioPublico}</span>
          <strong className="paragraph-3 bold naranja">{data.precioPVD}</strong>
          <span className="paragraph-3" style={{color: c.grisMedio}}>{data.precioPVP}</span> */}
        </div>
        <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro, justifyContent: 'space-between' }}>
          <CounterInput
            key={data.indice}
            vertical
            background={c.verdeClaro}
            color={"#fff"}
            borderColor={"#fff"}
            data={data}
            eventCounter={eventCounter}
          />
          {(data.icono == "1") ?
            <button
              className="btn-icon mt-3"
              disabled={data.cantidad == 0}
              onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
                codigo: data.codmaterial,
                descripcion: data.maktx,
                precioOferta: data.precio1,
                precioPublico: data.precio2,
                precioFinal: data.precio3,
                precioPVD: data.precioPVD,
                precioPVP: data.precioPVP,
                precioPublico: data.precioPublico,
                unidadMedida: data.meins,
                moneda: data.waers,
                cantidadOriginal: data.cantidad,
                cantidad: data.cantidad,
                pantalla: pantalla,
                pathI: data.pathImage,
                precios: data.precios,
                indice: data.indice,
                escalas: data.escalas
              })}
            >
              <SvgAssets icon="icon-add-cart" />
            </button>
            : null}
        </div>
      </div>
    )
  } else {
    card = (
      <div className="card_listado_repuesto">
        <Row form>
          <Col md={3} style={{ alignSelf: 'center' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => zoom(data.fotos)}>
              <img src={data.pathImage} />
            </div>
          </Col>
          <Col md={4} style={{ alignSelf: 'center' }}>
            <h6 className="paragraph-2 bold mb-1 azul">{data.maktx}</h6>
            <span className="paragraph-3" style={{ color: c.grisMedio }}>SKU: {data.codmaterial}</span>
          </Col>
          <Col md={1} style={{ alignSelf: 'center', textAlign: 'center' }}>
            <span className="paragraph-2 bold" style={{ color: c.azulClaro }}>{data.figura}</span>
          </Col>
          <Col md={1} style={{ alignSelf: 'center' }}>
            <CounterInput
              key={data.indice}
              vertical
              background={"#fff"}
              color={c.azulClaro}
              data={data}
              eventCounter={eventCounter}
            />
          </Col>
          <Col md={2} style={{ display: 'flex', alignItems: 'center' }}>
            <CardPrecios data={data.precios} escalas={data.escalas} cantidad={data.cantidad} className="cardPrice" />
            <button type="button"
              className="btn-icon"
              style={{ position: 'absolute', bottom: 0 }}
              onClick={() => eventFavorito({
                codigo: data.codmaterial, descripcion: data.maktx,
                moneda: data.waers, pantalla: "BuscarPedidoVehiculo.Repuesto"
              }, data.favorito, data.indice)}
            >
              <SvgAssets icon="icon-star" fill={c.celeste} fill={data.favorito ? c.amarillo : c.celeste} />
            </button>
          </Col>
          <Col md={1} className="add-cart">
            {(data.icono == "1") ?
              <button
                className="btn-icon"
                disabled={data.cantidad == 0}
                onClick={() => event(auth.carritoProdctos, auth.setcarritoProdctos, {
                  codigo: data.codmaterial,
                  descripcion: data.maktx,
                  precioOferta: data.precio1,
                  precioPublico: data.precio2,
                  precioFinal: data.precio3,
                  precioPVD: data.precioPVD,
                  precioPVP: data.precioPVP,
                  precioPublico: data.precioPublico,
                  unidadMedida: data.meins, moneda: data.waers,
                  cantidadOriginal: data.cantidad,
                  cantidad: data.cantidad,
                  pantalla: pantalla,
                  pathI: data.pathImage,
                  precios: data.precios,
                  indice: data.indice,
                  escalas: data.escalas
                })}
              >
                <SvgAssets icon="icon-add-cart" />
              </button>
              : null}
          </Col>
        </Row>
      </div>
    );
  }

  return card
}

export class Repuestos extends Component {
  static displayName = Repuestos.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      isMobile: isMobile,
      activeSlide: 0,
      addToCart: false,
      loading: true,
      repuestos: [],
      page: 1,
      size: data.PageSizeVehiculos,
      currentPage: 1,
      dealer: {},
      linea: {},
      asociado: {},
      params: {},
      titulo: "",
      imagen: "",
      addToCart: false,
      dataToCard: {},
      modalZoom: false,
      imgZoom: "",
      listImgZoom: [],
      selectedAnioValue: "",
      selectedModeloValue: "",
      selectedVehiculoValue: ""
    };
  }
  loadIrBuscador = () => {

    let datosBuscador = this.state.params;

    this.props.history.push({
      pathname: '/generar-pedido',
      state: { datosBuscador }
    });
  };

  checkParams(fn = () => { }) {
    const { state } = this.props.location;
    let parametro = state.datosBuscador;
    console.log("checkParams===>", parametro);
    this.setState({
      params: parametro
    }, fn)
  }
  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: Array.isArray(img) ? "" : img,
      listImgZoom: Array.isArray(img) ? img : [],
    }));
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      this.checkParams(() => {
        let data = localStorageCustom.prototype.getUsuario()
        this.setState({
          dealer: data.dealer,
          linea: data.linea,
          asociado: data.asociado,
          imagen: this.state.params.Linkimg,
        }, () => {
          this.postListarSistemaRepuestos(data.dealer, data.linea, data.asociado, this.state.params, this.state.page);
        })
      }
      );
    } else
      window.location.href = "/";
  }

  render() {
    const navigation = this.props.navigation;
    const { params, addToCart, loading, titulo, imagen, repuestos, page, currentPage, size, isMobile } = this.state;
    const auth = this.context;

    var slider_destacados = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Generar pedidos</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li><a onClick={this.loadIrBuscador} style={{ cursor: 'pointer' }}>Generar Pedido</a></li>
              <li>{params.Sistemaweb}</li>
            </ul>
          </Container>
        </div>
        <form className="busqueda-pedido mobile" style={{ backgroundColor: c.verdeClaro }}>
          <h6 className="title-4" style={{ color: '#fff' }}><Link to='/generar-pedido' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link>{params.Sistemaweb}</h6>
        </form>
        <div className="container_whit_menu">
          <div className="container_left">
            <Container style={{ backgroundColor: '#fff', position: 'relative' }}>
              <h6 className="desktop_titulo2 desktop" style={{ color: c.verdeClaro }}>{params.Sistemaweb}</h6>
              <SvgAssets icon="curve-bottom" className='curve-top mobile' fill={c.verdeClaro} />
              {
                (imagen != "") ?
                  <img className="img-repuestos" src={imagen} style={{ cursor: 'pointer' }} onClick={() => this.toggleModalZoom(imagen)} />
                  : null
              }
            </Container>
          </div>
          <div className="container_right">
            <Container className="pb-5" style={{ backgroundColor: '#fff', position: 'relative' }}>
              <div className="header_list desktop">
                <Row form>
                  <div style={{ flex: 2 }} />
                  <div style={{ flex: 0.5 }} className="text-center"><span>N° de parte</span></div>
                  <div style={{ flex: 0.4 }}><span>Cantidad</span></div>
                  <div style={{ flex: 0.8 }}><span>Precio<TooltipLeyenda color={c.azulClaro} style={{ position: 'absolute', right: 0, bottom: 10 }} /></span></div>
                </Row>
              </div>
              <div className="cards-wrap">
                {repuestos.map((item, index) => {
                  return (
                    <CardRepuestos
                      key={index}
                      eventFavorito={this.postAgregarProductoFavorito}
                      eventCounter={this.setCounter}
                      event={this.postAgregarProductoPedido}
                      pantalla={data.Pantalla.BuscarPedidoVehiculo.Repuesto}
                      data={item}
                      auth={auth}
                      isMobile={isMobile}
                      zoom={this.toggleModalZoom}
                    />
                  )
                })}
              </div>
              {(repuestos.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={repuestos[0].totalPage} size={data.PageSizePaginator} /> : null}
            </Container>
          </div>
        </div>
        <ModalImageZoom2 dadComponent={this} />
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
      </div>
    );
  }

  postListarSistemaRepuestos = async (dealer, linea, asociado, params, index) => {

    ListarSistemaRepuestos(params.Catalogo, params.Linkimg, asociado.moneda,
      params.Pagina, asociado.poblacion, params.Sistemaweb,
      dealer.codcliente, dealer.correoElectronico, linea.vkorg, index)
      .then(result => {
        if (result.mo.type == "success") {

          this.setState({
            loading: false,
            repuestos: result.dto.sistemaRepuestos,
            titulo: result.dto.sistemaRepuestos[0].sistema,
            // imagen: result.dto.sistemaRepuestos[0].linkimg,
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }
  setCounter = (counter, tab, index) => {
    let _repuestos = this.state.repuestos
    if (counter == "") {
      _repuestos[index].cantidad = 0;
    } else {
      _repuestos[index].cantidad = counter;
    }
    this.setState({
      repuestos: _repuestos
    })
  }
  setPage = (index, change, type) => {
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({
        page: index,
        currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1)
      })
    }
    else
      this.setState({ page: index })


    this.setState({
      loading: true
    })
    this.postListarSistemaRepuestos(this.state.dealer,
      this.state.linea,
      this.state.asociado,
      this.state.params, index);
  }

  postAgregarProductoFavorito = async (producto, AplicaFavorito, index) => {
    console.log(producto);
    this.setState({ loading: true })
    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito
    )
      .then(result => {
        if (result.mo.type == "success") {

          this.setState({ loading: false })
          let _data = this.state.repuestos
          _data[index].favorito = !AplicaFavorito;
          this.setState({
            repuestos: _data
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }

  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, producto) => {
    this.setState({ loading: true })

    AgregarProductoPedido(this.state.dealer, producto, this.state.linea, this.state.asociado)
      .then(result => {
        if (result.mo.type == "success") {


          let _repuestos = this.state.repuestos
          console.log("producto====>", producto);
          console.log("_repuestos====>", _repuestos);
          _repuestos[producto.indice].cantidad = 0;

          this.setState({ repuestos: _repuestos, loading: false, addToCart: true, dataToCard: producto })
          setcarritoProdctos(result.dto.carritoProdctos);

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Alerta", error.message ?? null);
        });
      });
  }

  setActiveSlide = (index) => {
    this.setState({ activeSlide: index })
  }
  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }
  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }
  showSistema = () => {
    this.setState({ addToCart: false, loading: false }, () => {
      this.props.history.push('/buscador-vehiculo');
    });
  }
}
